export interface IDecisionDialog {
	title: string;
	btnYes: string;
	btnNo: string;
	yesResult: any;
	noResult: any;
}
